import { IndexedDbStorage } from '../domain/IndexedDbStorage'
import type { StorageInstance } from '../domain/Storage'
import type { StorageProps } from '../types'

const instances: Map<string, StorageInstance> = new Map()

export const getStorageInstance = (
	storageProps: StorageProps
): StorageInstance => {
	const { cacheKey } = storageProps
	if (!instances.has(cacheKey)) {
		const instance: StorageInstance = new IndexedDbStorage(storageProps)
		instances.set(cacheKey, instance)
	}
	return instances.get(cacheKey) as StorageInstance
}
